import { Type } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { ButtonText } from './button-text.type';
import { ConfirmationDialogData } from './confirmation-dialog-data.type';

export abstract class ModalServiceBase {
  public abstract openConfirmationModal(
    modalData?: ConfirmationDialogData,
    buttonText?: ButtonText,
  ): Promise<boolean | undefined>;

  public abstract openModal<TComponent, TData, TResult>(
    component: Type<TComponent>,
    modalData?: TData,
    config?: MatDialogConfig<TData>,
  ): Promise<TResult | undefined>;

  public abstract openDialog<TComponent, TResult, TData>(
    component: Type<TComponent>,
    dialogData?: TData,
  ): Observable<TResult | undefined>;
}
